import { useTranslation } from "react-i18next";

const MAIN_SITE = "https://kaspreadsheet.com";

export default function FinalCta() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20cozy%20warm-toned%20shopping%20scene%20with%20kraft%20paper%20shopping%20bags%2C%20neatly%20folded%20clothing%20and%20a%20small%20potted%20plant%20on%20a%20cream%20surface%20with%20soft%20golden%20hour%20lighting%20and%20gentle%20shadows%2C%20minimal%20editorial%20lifestyle%20photography%2C%20warm%20neutral%20palette&width=1600&height=700&seq=cta-01&orientation=landscape&nocache=true"
          alt="Explore the USFans Spreadsheet main website"
          title="USFans Spreadsheet Main Website"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/45"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4">
            {t("final.title")}
          </h2>
          <p className="text-base md:text-lg text-background-50/90 leading-relaxed mb-8">
            {t("final.subtitle")}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href={MAIN_SITE}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto h-12 px-7 inline-flex items-center justify-center rounded-md bg-primary-500 text-background-50 font-semibold hover:bg-primary-600 transition whitespace-nowrap"
            >
              {t("final.explore")}
              <i className="ri-arrow-right-up-line ml-2"></i>
            </a>
            <a
              href={MAIN_SITE}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto h-12 px-7 inline-flex items-center justify-center rounded-md bg-background-50 text-foreground-950 font-semibold hover:bg-background-100 transition whitespace-nowrap"
            >
              {t("final.visit")}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}